module.exports = "\n.texto-footer{\n    font-family: 'Ubuntu'!important;\n    font-size: 11px;\n    color:grey;\n    padding-top: 10px;\n    margin-left: -100px!important;\n\n}\n\n.footer{\n    background-color: #fff;\n    border-top:1px solid rgba(0, 0, 0, 0.12);\n    height: 40px;\n    position: fixed;\n    width:100%;\n    bottom: 0px;\n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/footer/footer.component.css
// module id = ./src/app/ui/footer/footer.component.css
// module chunks = main